function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#141B21",
  fillRule: "nonzero",
  d: "M9.267.6l2.856 2.8L5.8 9.845l6.627 6.756-2.856 2.8L.198 9.844z"
});

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMTMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYzLjEgKDkyNDUyKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5jaGV2cm9uTGVmdDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJjaGV2cm9uTGVmdCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBvbHlnb24gaWQ9IlBhdGgiIGZpbGw9IiMxNDFCMjEiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSI5LjI2NzI5MTQ5IDAuNTk5NDExNDAyIDEyLjEyMjcwODUgMy40MDA1ODg2IDUuODAxIDkuODQ0IDEyLjQyNzgwMjQgMTYuNTk5NTA3MiA5LjU3MjE5NzU2IDE5LjQwMDQ5MjggMC4xOTgzOTk4MjIgOS44NDM5MDYwNCI+PC9wb2x5Z29uPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgChevronLeft as ReactComponent };